"use client"

import Foot from '@/component/layout/Foot';
import Head from '@/component/layout/Head';
import * as S from '@/component/layout/WebStyle';
import VideoSection from '@/component/section/index/VideoSection';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function WebLayout({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) {
    const pathname = usePathname();
    useEffect(() => {
        // console.log(pathname);
    }, [pathname]);

    return (
        <S.WebContainer>
            <Head />
            <VideoSection />
            <S.Body $isPadding={pathname === "/"}>
                {children}
            </S.Body>
            <Foot />
        </S.WebContainer>
    );
}
